import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from './Icon';
class QuickFixesIcon extends Component {
    render() {
        const { t } = this.props;
        return _jsx(Icon, { name: "bolt", title: t('quickFixesHelp'), className: "mx-1 text-warning" });
    }
}
export default (withTranslation()(QuickFixesIcon));
